export default __webpack_public_path__ + "static/media/book-cover.90e662b2.jpg";